module.exports = __webpack_public_path__ + "img/ball_8_black.dc12f2bd.png";